import React, { Component } from "react";
import Signup from "../components/Signup";
import { withRouter } from "react-router-dom";
import { validateEmail } from "../util/ValidateEmail";
import { languages } from "../constants/languages";
import moment from "moment-timezone";
import ReactPixel from "react-facebook-pixel";
import { getCookieConsentValue } from "react-cookie-consent";

class SignupContainer extends Component {
  state = {
    firstName: "",
    name: "",
    email: "",
    password: "",
    passwordConfirm: "",
    errorMessage: "",
  };

  handleChange = (event) => {
    let newState = {};
    newState[event.target.name] = event.target.value;
    this.setState(newState);
  };

  handleSignup = (event) => {
    event.preventDefault();

    let domain =
      ((window.location.hostname || "").split(".") || [])[
        ((window.location.hostname || "").split(".") || []).length - 1
      ] || "";

    if (this.validateForm()) {
      window.firebase
        .auth()
        .createUserWithEmailAndPassword(
          this.state.email.toLowerCase(),
          this.state.password
        )
        .then((user) => {
          let consent = getCookieConsentValue();
          if (consent === "true") {
            ReactPixel.init("802314050594771");
            ReactPixel.track("CompleteRegistration", {});
          }
          if (window.firebase.analytics) {
            window.firebase.analytics().logEvent("sign_up", {
              method: "email",
            });
          }
          window.firebase
            .firestore()
            .collection("users")
            .doc(user.user.uid)
            .set({
              firstName: this.state.firstName,
              name: this.state.name,
              email: this.state.email.toLowerCase(),
              timezone: moment.tz.guess() || "",
              registeredOn: moment().unix(),
              registeredDomain: domain,
              registeredLang: languages.getLanguage(),
            });
          window.firebase
            .database()
            .ref("newUsers/" + user.user.uid)
            .set({
              name: this.state.name,
              email: this.state.email.toLowerCase(),
              registeredOn: moment().unix(),
              language: languages.getLanguage(),
            });
        })
        .catch(
          function (error) {
            // Handle Errors here.
            // var errorCode = error.code;
            var errorMessage = error.message;
            if (error.code === "auth/email-already-in-use") {
              errorMessage = languages.login.emailInUse;
            }
            this.setState({ errorMessage: errorMessage });
          }.bind(this)
        );
    } else {
      let errorMessage = languages.login.allFieldsRequired;
      if (!validateEmail(this.state.email)) {
        errorMessage = languages.login.invalidEmail;
      } else if (this.state.password.length < 6) {
        errorMessage = languages.login.passwordTooShort;
      } else if (this.state.password !== this.state.passwordConfirm) {
        errorMessage = languages.login.passwordsNotSame;
      }
      this.setState({ errorMessage: errorMessage });
    }
  };

  validateForm = () => {
    return (
      validateEmail(this.state.email) &&
      this.state.password.length > 5 &&
      this.state.password === this.state.passwordConfirm
    );
  };

  generateProps = () => ({
    ...this.state,
    handleChange: this.handleChange,
    handleSignup: this.handleSignup,
  });

  render() {
    const props = this.generateProps();
    return <Signup {...props} />;
  }
}

export default withRouter(SignupContainer);
